// /settings/company — «Компания» (009, FR-003): корпоративные домены и внешний доступ к протоколам
// (022). Меняет — settings.write; только для чтения раздел открывают и те, кто управляет доступом
// к протоколам (022, решение 3 плана: minutes.access.manage), — как в каталоге разделов.
import { createFileRoute } from '@tanstack/react-router';
import { CompanySettingsPage } from '../../../features/settings/CompanySettingsPage.tsx';
import { can, requireSection } from '../../../shell/permissions.ts';
import { meQuery } from '../../../shell/session.ts';

export const Route = createFileRoute('/_app/_settings/settings/company')({
  beforeLoad: async (options) => {
    const me = await options.context.queryClient.ensureQueryData(meQuery());
    if (can(me.permissions, ['minutes.access.manage'])) return;
    await requireSection('settings')(options);
  },
  staticData: { crumb: 'Компания' },
  component: CompanySettingsPage,
});
